/* eslint-disable no-unused-vars */
import { createContext, useContext, useEffect, useState } from 'react'

import { DBContext } from './databases'

import jobStatJSON from '../data/Player/job_stats.json'
import jobASPDJSON from '../data/Player/job_aspd.json'
import * as jobsID from '../data/jobID'
import { getPassiveSkillsBonuses } from '../constants/passiveSkills'
import { getBuffsBonuses } from '../constants/buffs'

import { bonusRegex, autobonusRegex, skillRegex } from '../data/Items/NoaScript'

import { Item, Character } from './databases'

import { /*BonusParam,*/ BonusVariables } from '../constants/itemBonus2'

export const CharacterContext = createContext()

export const CharacterProvider = ({ children }) => {
	const cleanInventory = {
		Head_Top: new Item('Head_Top', true),
		Head_Mid: new Item('Head_Mid', false),
		Head_Low: new Item('Head_Low', false),
		Armor: new Item('Armor', true),
		Right_Hand: new Item('Right_Hand', true),
		Left_Hand: new Item('Left_Hand', true),
		Garment: new Item('Garment', true),
		Shoes: new Item('Shoes', true),
		Right_Accessory: new Item('Right_Accessory', false),
		Left_Accessory: new Item('Left_Accessory', false),
		Shadow_Weapon: new Item('Shadow_Weapon', true),
		Shadow_Shield: new Item('Shadow_Shield', true),
		Shadow_Armor: new Item('Shadow_Armor', true),
		Shadow_Shoes: new Item('Shadow_Shoes', true),
		Shadow_Right_Accessory: new Item('Shadow_Right_Accessory', true),
		Shadow_Left_Accessory: new Item('Shadow_Left_Accessory', true),
		Ammo: new Item('Ammo', false),
	}
	const { item_db_equip, item_ammo, isDbRefreshed } = useContext(DBContext)
	const [bonuses, setBonuses] = useState([])
	const [inventory, setInventory] = useState(cleanInventory)
	const [tempInventory, setTempInventory] = useState(null)
	const [activeCombos, setActiveCombos] = useState([])
	const [maxRefine] = useState({
		Head_Top: 20,
		Head_Mid: 0,
		Head_Low: 0,
		Armor: 20,
		Right_Hand: 20,
		Left_Hand: 20,
		Garment: 20,
		Shoes: 20,
		Right_Accessory: 0,
		Left_Accessory: 0,
		Shadow_Weapon: 10,
		Shadow_Shield: 10,
		Shadow_Armor: 10,
		Shadow_Shoes: 10,
		Shadow_Right_Accessory: 10,
		Shadow_Left_Accessory: 10,
	})
	//Base Stats
	const [baseSTR, setBaseSTR] = useState(Number(1))
	const [baseAGI, setBaseAGI] = useState(Number(1))
	const [baseVIT, setBaseVIT] = useState(Number(1))
	const [baseINT, setBaseINT] = useState(Number(1))
	const [baseDEX, setBaseDEX] = useState(Number(1))
	const [baseLUK, setBaseLUK] = useState(Number(1))
	const [basePOW, setBasePOW] = useState(Number(0))
	const [baseSTA, setBaseSTA] = useState(Number(0))
	const [baseWIS, setBaseWIS] = useState(Number(0))
	const [baseSPL, setBaseSPL] = useState(Number(0))
	const [baseCON, setBaseCON] = useState(Number(0))
	const [baseCRT, setBaseCRT] = useState(Number(0))

	const replaceItemInInventory = (newItem) => {
		let newInventory = {}
		//copy value of previous inventory
		Object.keys(inventory).forEach(function (key, index) {
			newInventory[key] = inventory[key]
		})

		//replace new item in inventory
		newInventory[newItem.Location] = newItem
		// console.log(newInventory)
		setInventory(newInventory)
	}
	const [equipSets, setEquipSets] = useState([])

	const [jobStat] = useState(jobStatJSON)
	const [jobsASPD] = useState(jobASPDJSON)

	const changeEquipSets = function (newSets) {
		setEquipSets(newSets)
	}
	const setNewInventory = (tempInvent) => {
		let newInventory = {}
		Object.entries(inventory).forEach(([Location, item]) => {
			let itemFromDb = item_db_equip.find(
				(itmDB) => itmDB.Id === tempInvent[Location].Id,
			)
			let newItem = new Item(Location, item.isRefinable)

			if (itemFromDb) {
				newItem.setItem(itemFromDb)
				Object.entries(tempInvent[Location].CardSlots).forEach(
					([Slot, Compound]) => {
						newItem.CardSlots[Slot].changeSlot(Compound)
					},
				)
				newItem.setRefine(tempInvent[Location].refine)
			}
			newInventory[newItem.Location] = newItem
		})
		setInventory(newInventory)
	}
	useEffect(() => {
		// setNewInventory()
		if (tempInventory && isDbRefreshed) {
			// console.log('tempInventory')
			// console.log(tempInventory)
			let newInventory = {}
			Object.entries(inventory).forEach(([Location, item]) => {
				let itemFromDb = item_db_equip.find(
					(itmDB) => itmDB.Id === tempInventory[Location]?.Id,
				)
				if (Location === 'Ammo') {
					itemFromDb = item_ammo.find(
						(itmDB) => itmDB.Id === tempInventory[Location]?.Id,
					)
				}
				let newItem = new Item(Location, item.isRefinable)
				if (itemFromDb) {
					newItem.setItem(itemFromDb)
					Object.entries(tempInventory[Location]?.CardSlots).forEach(
						([Slot, Compound]) => {
							newItem.CardSlots[Slot].changeSlot(Compound)
						},
					)
					newItem.setRefine(tempInventory[Location].refine)
				}
				newInventory[newItem.Location] = newItem
			})
			setInventory(newInventory)
			setTempInventory(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_db_equip, isDbRefreshed, tempInventory])

	useEffect(() => {
		setActiveCombos(
			//return object with active combos and scripts
			equipSets.map((sets) => {
				return {
					Combos: sets.Combos.filter((combos) =>
						combos.Combo.every((combo) =>
							[
								inventory['Head_Top'].AegisName,
								inventory['Head_Top'].CardSlots[0].AegisName,
								inventory['Head_Mid'].AegisName,
								inventory['Head_Mid'].CardSlots[0].AegisName,
								inventory['Head_Low'].AegisName,
								inventory['Armor'].AegisName,
								inventory['Armor'].CardSlots[0].AegisName,
								inventory['Right_Hand'].AegisName,
								inventory['Right_Hand'].CardSlots[0].AegisName,
								inventory['Right_Hand'].CardSlots[1].AegisName,
								inventory['Right_Hand'].CardSlots[2].AegisName,
								inventory['Right_Hand'].CardSlots[3].AegisName,
								inventory['Left_Hand'].AegisName,
								inventory['Left_Hand'].CardSlots[0].AegisName,
								inventory['Left_Hand'].CardSlots[1].AegisName,
								inventory['Left_Hand'].CardSlots[2].AegisName,
								inventory['Left_Hand'].CardSlots[3].AegisName,
								inventory['Garment'].AegisName,
								inventory['Garment'].CardSlots[0].AegisName,
								inventory['Shoes'].AegisName,
								inventory['Shoes'].CardSlots[0].AegisName,
								inventory['Right_Accessory'].AegisName,
								inventory['Right_Accessory'].CardSlots[0]
									.AegisName,
								inventory['Left_Accessory'].AegisName,
								inventory['Left_Accessory'].CardSlots[0]
									.AegisName,
								inventory['Shadow_Weapon'].AegisName,
								inventory['Shadow_Shield'].AegisName,
								inventory['Shadow_Armor'].AegisName,
								inventory['Shadow_Shoes'].AegisName,
								inventory['Shadow_Right_Accessory'].AegisName,
								inventory['Shadow_Left_Accessory'].AegisName,
								inventory['Ammo']?.AegisName,
							].includes(combo),
						),
					),
					Script: sets.Script,
				}
			}),
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [equipSets])

	//Jobs
	const [job, setJob] = useState(Number(0))
	// const [jobParam, setJobParam] = useState(0)
	const [jobASPD, setJobASPD] = useState(0)
	const changeJob = (jobID) => {
		setJob(Number(jobID))
	}
	//BaseLevel
	const [baseLevel, setBaseLevel] = useState(Number(1))
	const changeBaseLevel = (value) => {
		setBaseLevel(Number(value))
	}
	//JobLevel
	const [jobLevel, setJobLevel] = useState(Number(1))
	const changeJobLevel = (value) => {
		setJobLevel(Number(value))
	}

	const changeBaseStat = (value, stat) => {
		let numValue = Number(value)
		switch (stat) {
			case 'str':
				setBaseSTR(numValue)
				break
			case 'agi':
				setBaseAGI(numValue)
				break
			case 'vit':
				setBaseVIT(numValue)
				break
			case 'int':
				setBaseINT(numValue)
				break
			case 'dex':
				setBaseDEX(numValue)
				break
			case 'luk':
				setBaseLUK(numValue)
				break
			default:
				break
		}
	}
	const getBaseStat = (stat) => {
		switch (stat) {
			case 'str':
				return baseSTR
			case 'agi':
				return baseAGI
			case 'vit':
				return baseVIT
			case 'int':
				return baseINT
			case 'dex':
				return baseDEX
			case 'luk':
				return baseLUK
			default:
				break
		}
	}
	//Bonus Stats
	const [bonusSTR, setBonusSTR] = useState(Number(0))
	const [bonusAGI, setBonusAGI] = useState(Number(0))
	const [bonusVIT, setBonusVIT] = useState(Number(0))
	const [bonusINT, setBonusINT] = useState(Number(0))
	const [bonusDEX, setBonusDEX] = useState(Number(0))
	const [bonusLUK, setBonusLUK] = useState(Number(0))
	// const addBonus = (func, newBonus) =>
	// 	func((prevBonus) => prevBonus + newBonus)

	const [jobSTR, setJobSTR] = useState(Number(0))
	const [jobAGI, setJobAGI] = useState(Number(0))
	const [jobVIT, setJobVIT] = useState(Number(0))
	const [jobINT, setJobINT] = useState(Number(0))
	const [jobDEX, setJobDEX] = useState(Number(0))
	const [jobLUK, setJobLUK] = useState(Number(0))
	const addJobStatBonus = (bonus) => {
		let bstr = 0
		let bagi = 0
		let bvit = 0
		let bint = 0
		let bdex = 0
		let bluk = 0

		bonus.forEach((bon) => {
			if (bon.Level <= jobLevel) {
				if (bon.Str) bstr += bon.Str
				if (bon.Agi) bagi += bon.Agi
				if (bon.Vit) bvit += bon.Vit
				if (bon.Int) bint += bon.Int
				if (bon.Dex) bdex += bon.Dex
				if (bon.Luk) bluk += bon.Luk
			}
		})

		//set the new job bonus stat variable
		setJobSTR(Number(bstr))
		setJobAGI(Number(bagi))
		setJobVIT(Number(bvit))
		setJobINT(Number(bint))
		setJobDEX(Number(bdex))
		setJobLUK(Number(bluk))
	}

	//player
	// const [player, setPlayer] = useState(
	// 	new Character(
	// 		{ baseSTR, baseAGI, baseVIT, baseINT, baseDEX, baseLUK },
	// 		job,
	// 		baseLevel,
	// 		jobLevel,
	// 		inventory,
	// 	),
	// )
	const refreshPlayer = () => {
		const newPlayer = new Character(
			{ baseSTR, baseAGI, baseVIT, baseINT, baseDEX, baseLUK },
			job,
			baseLevel,
			jobLevel,
			inventory,
		)
		// setPlayer(newPlayer)
		return newPlayer
	}

	useEffect(() => {
		let bonus = jobStat.find(function (currentJob) {
			return currentJob.Jobs[jobsID.getFormatedClassName(job)]
		})
		if (bonus) addJobStatBonus(bonus.BonusStats)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jobStat, jobLevel, job])

	useEffect(() => {
		let aspd = jobsASPD.find(
			(currentJob) => currentJob.Jobs[jobsID.getFormatedClassName(job)],
		)
		if (aspd) setJobASPD(aspd)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jobsASPD, jobLevel, job])

	const [statPoints, setStatPoints] = useState(Number(40))
	useEffect(() => {
		let statpoints = 48
		if (job & jobsID.EAJL_UPPER) {
			// trans
			statpoints = 100
		}
		for (var i = 1; i < baseLevel; i++) {
			if (i <= 100) {
				statpoints += Math.floor(i / 5) + 3
			} else if (i <= 150) {
				statpoints += Math.floor(i / 10) + 13
			} else {
				statpoints += Math.floor((i - 150) / 7) + 28
			}
		}

		statpoints -= usedStatPoints(baseSTR)
		statpoints -= usedStatPoints(baseAGI)
		statpoints -= usedStatPoints(baseVIT)
		statpoints -= usedStatPoints(baseINT)
		statpoints -= usedStatPoints(baseDEX)
		statpoints -= usedStatPoints(baseLUK)

		setStatPoints(statpoints)
	}, [baseLevel, job, baseSTR, baseAGI, baseVIT, baseINT, baseDEX, baseLUK])

	const [STR, setSTR] = useState(Number(1))
	useEffect(() => {
		setSTR(baseSTR + bonusSTR)
	}, [baseSTR, bonusSTR])
	const [AGI, setAGI] = useState(Number(1))
	useEffect(() => {
		setAGI(baseAGI + bonusAGI)
	}, [baseAGI, bonusAGI])
	const [VIT, setVIT] = useState(Number(1))
	useEffect(() => {
		setVIT(baseVIT + bonusVIT)
	}, [baseVIT, bonusVIT])
	const [INT, setINT] = useState(Number(1))
	useEffect(() => {
		setINT(baseINT + bonusINT)
	}, [baseINT, bonusINT])
	const [DEX, setDEX] = useState(Number(1))
	useEffect(() => {
		setDEX(baseDEX + bonusDEX)
	}, [baseDEX, bonusDEX])
	const [LUK, setLUK] = useState(Number(1))
	useEffect(() => {
		setLUK(baseLUK + bonusLUK)
	}, [baseLUK, bonusLUK])

	const [extraATK, setExtraATK] = useState(Number(0))
	const [masteryATK, setMasteryATK] = useState(Number(0))

	useEffect(() => {
		// console.log('inventory?.Ammo', inventory?.Ammo)
		setExtraATK(
			(bonuses.bBaseAtk ? bonuses.bBaseAtk : 0) +
				(bonuses.bAtk ? bonuses.bAtk : 0) +
				(bonuses.bAtk2 ? bonuses.bAtk2 : 0) +
				(inventory?.Ammo?.Attack ? inventory.Ammo.Attack : 0),
		)
		setBonusSTR(
			(bonuses.bStr ? bonuses.bStr : 0) +
				(bonuses.bAllStats ? bonuses.bAllStats : 0) +
				jobSTR,
		)
		setBonusAGI(
			(bonuses.bAgi ? bonuses.bAgi : 0) +
				(bonuses.bAllStats ? bonuses.bAllStats : 0) +
				jobAGI,
		)
		setBonusVIT(
			(bonuses.bVit ? bonuses.bVit : 0) +
				(bonuses.bAllStats ? bonuses.bAllStats : 0) +
				jobVIT,
		)
		setBonusINT(
			(bonuses.bInt ? bonuses.bInt : 0) +
				(bonuses.bAllStats ? bonuses.bAllStats : 0) +
				jobINT,
		)
		setBonusDEX(
			(bonuses.bDex ? bonuses.bDex : 0) +
				(bonuses.bAllStats ? bonuses.bAllStats : 0) +
				jobDEX,
		)
		setBonusLUK(
			(bonuses.bLuk ? bonuses.bLuk : 0) +
				(bonuses.bAllStats ? bonuses.bAllStats : 0) +
				jobLUK,
		)
		// console.log(bonuses)
	}, [
		bonuses,
		inventory.Ammo,
		jobAGI,
		jobDEX,
		jobINT,
		jobLUK,
		jobSTR,
		jobVIT,
	])

	useEffect(() => {
		setInventory(cleanInventory)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [job])

	function newAddBonus(equip, newBonus) {
		//bonuses related function and variables
		// eslint-disable-next-line no-unused-vars
		function getrefine() {
			return equip.refine ? equip.refine : 0
		}
		// eslint-disable-next-line no-unused-vars
		function readparam(param) {
			return param
		}
		// eslint-disable-next-line no-unused-vars
		function getskilllv(SkillToGet) {
			let searchedSkill = skills.find((sk) => sk.AegisName === SkillToGet)

			return searchedSkill ? searchedSkill.skillLevel : 0
		}
		// eslint-disable-next-line no-unused-vars
		function eaclass() {
			return job
		}
		// eslint-disable-next-line no-unused-vars
		function getequipweaponlv() {
			return inventory['Right_Hand'].WeaponLevel
		}
		// eslint-disable-next-line no-unused-vars
		function getequiprefinerycnt(eq) {
			// console.log(eq.Location + ' : +' + eq.refine)
			return eq.refine
		}
		function getBaseJob(j) {
			jobsID.getFormatedClassName(
				job &
					~jobsID.THIRDMASK &
					~jobsID.UPPERMASK &
					~jobsID.EAJL_2 &
					~jobsID.IS_MALE,
			)
		}
		function hateffect() {
			return 0
		}
		function itemskill() {
			return 0
		}
		function getitempos() {
			// switch(equip.Location)
			// {
			// 	case 'Right_Accessory':
			// 		return
			// 	case 'Left_Accessory':
			// 	default:
			// 		break;
			// }
			return equip.Location
		}
		/**
		 *
		 * @param {*} id
		 * @param {*} unknowValue
		 * @returns weapon type
		 */
		function getiteminfo(id, info) {
			// console.log('getiteminfo : ' + info)
			if (info === 11) return id.SubType
			if (info === 12) return id.WeaponLevel
			return id[info]
		}
		function getequipid(EQ) {
			return EQ
		}
		function isequipped() {
			return 0
		}
		function getequiparmorlv() {
			return equip.ArmorLevel
		}

		function getpetinfo(info) {
			//TODO
			if (info === 'PETINFO_EGGID') return 0
			if (info === 'PETINFO_INTIMATE') return 0
		}

		function gettime(date) {
			return 0
		}

		function strcharinfo(num) {
			//3 = return current map, will not be done on sim
			return 0
		}
		function getenchantgrade() {
			return 0
		}

		// eslint-disable-next-line no-unused-vars
		function bonus(bonus_type, bonus_value) {
			//i don't know why i did this ???
			// bonus_value = !isNaN(bonus_value) ? bonus_value : true
			switch (bonus_type) {
				case 'bVariableCastrate':
				case 'bFixedCastrate':
					//if not exist, make an array then push the new value
					newBonus[bonus_type] = newBonus[bonus_type]
						? newBonus[bonus_type]
						: []
					newBonus[bonus_type]['All'] =
						(newBonus[bonus_type]['All']
							? newBonus[bonus_type]['All']
							: 0) + Math.floor(bonus_value)
					break
				case 'bAddItemHealRate':
				case 'bAddItemSPHealRate':
					//if not exist, make an array then push the new value
					newBonus[bonus_type] = newBonus[bonus_type]
						? newBonus[bonus_type]
						: []
					newBonus[bonus_type].push({
						ID: 0,
						Rate: bonus_value,
					})

					break
				case 'bDefRatioAtkClass':
				case 'bIgnoreDefClass':
				case 'bIgnoreDefRace':
					//if not exist, make an array then push the new value
					newBonus[bonus_type] = newBonus[bonus_type]
						? newBonus[bonus_type]
						: []
					newBonus[bonus_type].push({
						Class: bonus_value,
					})

					break
				case 'bAtkEle':
				case 'bDefEle':
					newBonus[bonus_type] = bonus_value
					break
				default:
					newBonus[bonus_type] =
						(newBonus[bonus_type] ? newBonus[bonus_type] : 0) +
						Math.floor(bonus_value)
					break
			}
		}
		// eslint-disable-next-line no-unused-vars
		function bonus2(bonus_type, bonus_value1, bonus_value2) {
			// if (bonus_type === 'bDropAddRace' && isNaN(bonus_value2)) {
			// 	console.log('value : ' + getrefine())
			// 	console.log(equip.Script)
			// }
			//cases for differents possible issues
			switch (bonus_type) {
				case 'bHPDrainRate':
				case 'bSPDrainRate':
				case 'bHPVanishRate':
				case 'bSPVanishRate':
				case 'bGetZenyNum':
				case 'bAddGetZenyNum':
				case 'bHPLossRate':
				case 'bHPRegenRate':
				case 'bRegenPercentHP':
				case 'bRegenPercentSP':
				case 'bSPLossRate':
				case 'bSPRegenRate':
					//if not exist, make an array then push the new value
					newBonus[bonus_type] = newBonus[bonus_type]
						? newBonus[bonus_type]
						: []
					newBonus[bonus_type].push({
						Rate: bonus_value1,
						Amount: bonus_value2,
					})
					break
				case 'bAddMonsterDropItem':
				case 'bAddItemHealRate':
				case 'bAddItemSPHealRate':
				case 'bAddDamageClass':
				case 'bAddDefMonster':
					// case 'bAddClass':
					//if not exist, make an array then push the new value
					newBonus[bonus_type] = newBonus[bonus_type]
						? newBonus[bonus_type]
						: []
					newBonus[bonus_type].push({
						ID: bonus_value1,
						Rate: bonus_value2,
					})

					break
				default:
					//if not exist, make an array then push the new value
					newBonus[bonus_type] = newBonus[bonus_type]
						? newBonus[bonus_type]
						: []
					newBonus[bonus_type][bonus_value1] =
						(newBonus[bonus_type][bonus_value1]
							? newBonus[bonus_type][bonus_value1]
							: 0) + Math.floor(bonus_value2)
					break
			}
		}
		// eslint-disable-next-line no-unused-vars
		function bonus3(bonus_type, bonus_value1, bonus_value2, bonus_value3) {
			if (
				bonus_type === 'bHPVanishRaceRate' ||
				bonus_type === 'bHPVanishRate' ||
				bonus_type === 'bSPVanishRaceRate' ||
				bonus_type === 'bSPVanishRate'
			) {
				//handle sp aborb part
			} else {
				//function here
				// console.log(
				// 	bonus_type + ' : ' + bonus_value1 + ' :' + bonus_value2
				// )
			}
		}
		// eslint-disable-next-line no-unused-vars
		function bonus4(bon, value1, value2, value3, value4) {
			// console.log(bon + ' : ' + value1 + ' :' + value2)
		}
		// eslint-disable-next-line no-unused-vars
		function bonus5(bon, value1, value2, value3, value4, value5) {
			// console.log(bon + ' : ' + value1 + ' :' + value2)
		}
		// eslint-disable-next-line no-unused-vars
		function autobonus(bonus_type, bonus_value) {
			// console.log('effect : ' + bonus_type + ' = ' + bonus_value)
		}
		// eslint-disable-next-line no-unused-vars
		function autobonus2(bon, value1, value2) {
			// console.log(bon + ' : ' + value1 + ' :' + value2)
		}
		// eslint-disable-next-line no-unused-vars
		function autobonus3(bon, value1, value2, value3) {
			// console.log(bon + ' : ' + value1 + ' :' + value2)
		}
		// eslint-disable-next-line no-unused-vars
		function skill(skillName, skillLevel) {
			// console.log('add ' + skillName + ' lv.' + skillLevel)
		}

		// * Trigger criteria (bf)
		const BF_SHORT = 0 //= Trigger on melee attacks
		const BF_LONG = 1 //= Trigger on ranged attacks
		// (Default: BF_SHORT+BF_LONG)

		const BF_WEAPON = 0 //= Trigger on weapon skills
		const BF_MAGIC = 1 //= Trigger on magic skills
		const BF_MISC = 2 //= Trigger on misc skills
		// (Default: BF_WEAPON)

		const BF_NORMAL = 0 //= Trigger on normal attacks
		const BF_SKILL = 1 //= Trigger on skills
		// (Default: BF_SKILL if type is BF_MISC or BF_MAGIC, BF_NORMAL if type is BF_WEAPON)

		// * Trigger criteria (atf)
		// Effect target: (Default: Attacked target)
		const ATF_SELF = 0x01 //= Trigger effect on self
		const ATF_TARGET = 0x02 //= Trigger effect on target

		// Attack range criteria: (Default: All attacks)
		const ATF_SHORT = 0x04 //= Trigger on melee attacks
		const ATF_LONG = 0x08 //= Trigger on ranged attacks

		// Skill/attack type criteria: (Default: Physical/weapon)
		const ATF_SKILL = 0x20 | 0x40 //= Trigger on magic/misc skills
		const ATF_WEAPON = 0x10 //= Trigger on weapon skill / physical attacks
		const ATF_MAGIC = 0x20 //= Trigger on magic skills
		const ATF_MISC = 0x40 //= Trigger on misc skills
		// try{
		// eslint-disable-next-line no-eval
		eval(scriptParser(BonusVariables + (equip.Script ? equip.Script : '')))
		// } catch (e) {
		// 	console.log(e)
		// 	debugscriptParser(equip.Script ? equip.Script : '')
		// }
		equip.CardSlots?.map((cardSlot, index) =>
			// eslint-disable-next-line no-eval
			eval(
				scriptParser(
					BonusVariables + (cardSlot.Script ? cardSlot.Script : ''),
				),
			),
		)
		return newBonus
	}

	const [skills, setSkills] = useState([])
	// useEffect(() => {}, [skills])
	useEffect(() => {
		// console.log(masteryATK)
	}, [masteryATK])

	useEffect(() => {
		// console.log('inventory changed')
		// console.log(inventory)
		let newBonuses = []

		//exec bonuses script for all inventory
		Object.keys(inventory).forEach(function (key, index) {
			newAddBonus(inventory[key], newBonuses)
		})

		//exec bonuses for each combos
		activeCombos.map((combo) => {
			let newItem = new Item('Combo', false)
			newItem.Script = combo.Script
			//each sets with the same combo effect is added to 'Combos' array
			for (let i = 0; i < combo.Combos.length; i++)
				newAddBonus(newItem, newBonuses)
			return 0
		})
		// console.log(newBonuses)
		// newBonuses = addSkillBonuses(newBonuses, skills)
		getPassiveSkillsBonuses(
			newBonuses,
			inventory,
			baseLevel,
			job,
			getSkillLevel,
		)
		getBuffsBonuses(newBonuses, getSkillLevel)
		// console.log('newBonuses', newBonuses)
		setBonuses(newBonuses)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		inventory,
		skills,
		activeCombos,
		baseSTR,
		baseAGI,
		baseVIT,
		baseINT,
		baseDEX,
		baseLUK,
		baseLevel,
		jobLevel,
	])

	// useEffect(() => {}, [inventory])
	function getSkillLevel(SkillToGet) {
		let searchedSkill = skills.find((sk) => sk.AegisName === SkillToGet)

		return searchedSkill ? searchedSkill.skillLevel : 0
	}

	const [buffs, setBuffs] = useState([])
	useEffect(() => {
		// console.log(buffs)
	}, [buffs])

	const searchAndSetOptions = (options, searchedValue, setFunction) => {
		if (options.length > 0) {
			let newopt = options.find((opt) => opt.value === searchedValue)
			if (newopt) {
				setFunction(newopt)
			}
		}
	}
	return (
		<CharacterContext.Provider
			value={{
				job,
				changeJob,
				jobASPD,
				changeBaseStat,
				getBaseStat,
				bonusSTR,
				bonusAGI,
				bonusVIT,
				bonusINT,
				bonusDEX,
				bonusLUK,
				statPoints,
				STR,
				AGI,
				VIT,
				INT,
				DEX,
				LUK,
				jobLevel,
				changeJobLevel,
				baseLevel,
				changeBaseLevel,
				inventory,
				maxRefine,
				changeEquipSets,
				replaceItemInInventory,
				extraATK,
				skills,
				setSkills,
				bonuses,
				// setBonuses,
				newAddBonus,
				buffs,
				setBuffs,
				// player,
				refreshPlayer,
				setInventory,
				setNewInventory,
				tempInventory,
				setTempInventory,
				searchAndSetOptions,
			}}
		>
			{children}
		</CharacterContext.Provider>
	)
}

export function jobNameFormat(JobName) {
	const jobName = JobName.toLowerCase().split('_')
	let output = []
	let convertedJobName = ''

	jobName.map((word) =>
		output.push(word.charAt(0).toUpperCase() + word.slice(1)),
	)

	convertedJobName = output[0]
	if (output.length > 1) {
		for (let i = 1; i < output.length; i++) {
			convertedJobName += '_' + output[i]
		}
	}

	return convertedJobName
}

function usedStatPoints(baseStatPoint) {
	let StPoint = 0
	for (var i = 2; i <= baseStatPoint; i++) {
		StPoint += statCalc(i)
	}
	return StPoint
}
function statCalc(stat) {
	// statToPoints
	if (stat <= 100) return Math.floor((stat - 2) / 10) + 2
	// if(nSC2<=CONST_MAXSTAT_THIRD)
	if (stat <= 130) return Math.floor((stat - 101) / 5) * 4 + 16
	return 0
}

function scriptParser(rawScript) {
	let script = rawScript ? rawScript.toString().split('\n') : ''
	for (let i = 0; i < script.length; i++) {
		let temp = script[i].split(' ')
		for (let j = 0; j < temp.length; j++) {
			//get rid of indentation
			if (temp[j] !== '') {
				if (temp[j] === 'bonus') {
					script[i] = bonusRegex('bonus', script[i])
				}
				if (temp[j] === 'bonus2') {
					script[i] = bonusRegex('bonus2', script[i])
				}
				if (temp[j] === 'bonus3') {
					script[i] = bonusRegex('bonus3', script[i])
				}
				if (temp[j] === 'bonus4') {
					script[i] = bonusRegex('bonus4', script[i])
				}
				if (temp[j] === 'bonus5') {
					script[i] = bonusRegex('bonus5', script[i])
				}

				if (temp[j] === 'autobonus') {
					script[i] = autobonusRegex('autobonus', script[i])
				}
				if (temp[j] === 'autobonus2') {
					script[i] = autobonusRegex('autobonus2', script[i])
				}
				if (temp[j] === 'autobonus3') {
					script[i] = autobonusRegex('autobonus3', script[i])
				}
				if (temp[j] === 'skill') {
					script[i] = skillRegex('skill', script[i])
				}
				if (temp[j] === 'hateffect') {
					script[i] = autobonusRegex('hateffect', script[i])
				}
				if (temp[j] === 'itemskill') {
					script[i] = autobonusRegex('itemskill', script[i])
				}
				j = temp.length
			}
		}
	}
	if (script.length > 0) script = script.join('\n')
	script = script.split('.@bonus')
	if (script.length > 0) script = script.join('.@bon')
	script = script.split('set .@bblvl,')
	if (script.length > 0) script = script.join('.@bblvl = ')
	script = script.split('set .@luk,')
	if (script.length > 0) script = script.join('.@luk = ')
	script = script.split('.@')
	if (script.length > 0) script = script.join('')
	script = script.split('floor(')
	if (script.length > 0) script = script.join('Math.floor(')
	script = script.split('pow(')
	if (script.length > 0) script = script.join('Math.pow(')
	script = script.split('min(')
	if (script.length > 0) script = script.join('Math.min(')
	script = script.split('max(')
	if (script.length > 0) script = script.join('Math.max(')
	//To avoid Math.Math., this should never happen.
	script = script.split('Math.Math.')
	if (script.length > 0) script = script.join('Math.')
	// script = transpileVariables(script)

	return script
}

function debugscriptParser(rawScript) {
	let script = rawScript ? rawScript.toString().split('\n') : ''
	console.log('rawscript')
	console.log(rawScript)
	for (let i = 0; i < script.length; i++) {
		let temp = script[i].split(' ')
		for (let j = 0; j < temp.length; j++) {
			//get rid of indentation
			if (temp[j] !== '') {
				if (temp[j] === 'bonus') {
					script[i] = bonusRegex('bonus', script[i])
				}
				if (temp[j] === 'bonus2') {
					console.log('this')
					script[i] = bonusRegex('bonus2', script[i])
				}
				if (temp[j] === 'bonus3') {
					script[i] = bonusRegex('bonus3', script[i])
				}
				if (temp[j] === 'bonus4') {
					script[i] = bonusRegex('bonus4', script[i])
				}
				if (temp[j] === 'bonus5') {
					script[i] = bonusRegex('bonus5', script[i])
				}

				if (temp[j] === 'autobonus') {
					script[i] = autobonusRegex('autobonus', script[i])
				}
				if (temp[j] === 'autobonus2') {
					script[i] = autobonusRegex('autobonus2', script[i])
				}
				if (temp[j] === 'autobonus3') {
					script[i] = autobonusRegex('autobonus3', script[i])
				}
				if (temp[j] === 'skill') {
					script[i] = skillRegex('skill', script[i])
				}
				if (temp[j] === 'hateffect') {
					script[i] = autobonusRegex('hateffect', script[i])
				}
				if (temp[j] === 'itemskill') {
					script[i] = autobonusRegex('itemskill', script[i])
				}
				j = temp.length
			}
		}
	}
	if (script.length > 0) script = script.join('\n')
	script = script.split('.@bonus')
	if (script.length > 0) script = script.join('.@bon')
	script = script.split('set .@bblvl,')
	if (script.length > 0) script = script.join('.@bblvl = ')
	script = script.split('set .@luk,')
	if (script.length > 0) script = script.join('.@luk = ')
	script = script.split('.@')
	if (script.length > 0) script = script.join('')
	script = script.split('floor(')
	if (script.length > 0) script = script.join('Math.floor(')
	script = script.split('pow(')
	if (script.length > 0) script = script.join('Math.pow(')
	script = script.split('min(')
	if (script.length > 0) script = script.join('Math.min(')
	script = script.split('max(')
	if (script.length > 0) script = script.join('Math.max(')
	// script = transpileVariables(script)
	console.log('finalscript')
	console.log(script)
	return script
}
